(ns teamoesterreich.firebase.fb-warning
  (:require
    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.util.log :as log]))



(defn get-filtered-warnings []
  (let [now (js/Date.now)
        warnings @(r/cursor store/app-state [:warnings])
        warnings (filter (fn [[wId w]]
                           (let [from (or (:notify-from w) (:validity-from w))]
                             (and (:active w)
                                  (and from
                                       (< (* (- (.-seconds ^js from) (* 24 3600)) 1000) now))
                                  (or (nil? (:validity-to w))
                                      (> (* (.-seconds ^js (:validity-to w)) 1000) now)
                                      ))))
                         warnings)
        ]
    warnings))



(defn location-in [locationId d-location d-warning]
  (let [{muni :municipality county :county state :state country :country} d-location
        warn-type (keyword (:type d-warning))
        warn-level (:level d-warning)
        min-warn-level 0                                    ;; only for notifications (or (get-in d-location [:warning-types warn-type]) 0)
        in-muni? (some #(= muni %) (:municipalities d-warning))
        in-county? (some #(= county %) (:counties d-warning))
        in-state? (some #(= state %) (:states d-warning))
        in-country? (some #(= country %) (:countries d-warning))
        has-userLocations? (coll? (:user-locations d-warning))
        in-userLocations? (some #(= locationId %) (:user-locations d-warning))
        inside? (and (not has-userLocations?) (or in-muni? in-county? in-state? in-country?))
        do-warn? (and (or in-userLocations? inside?) (>= warn-level min-warn-level))
        ]
    ;(log/out "counties :" county "in" (clj->js d-warning))
    ;(log/debug (str "warn-type:" warn-type " warn-level:" warn-level ">=" min-warn-level "-> do? " do-warn? " in-userLocations?" in-userLocations? " inside? " inside? "{" in-muni? in-county? in-state? in-country? " txt:" (:warntext d-warning)))
    (when do-warn? d-warning)
    ))

(defn get-actual-location-warnings [locationId]
  (let [d-location @(r/cursor store/app-state [:locations locationId])]
    (reverse (sort-by (fn [d-warning]
                        (log/out "SORT.... " (str (:type d-warning) "#" (:level d-warning)))
                        (str (:level d-warning) "#" (:type d-warning)
                             ))
                      (remove nil? (mapv (fn [[k d-warning]] (location-in locationId d-location d-warning))
                                         (get-filtered-warnings)))

                      ))))



(defn get-clustered-actual-location-warnings [locationId]
  (let [location-warnings (get-actual-location-warnings locationId)
        clustered-location-warnings (reduce (fn [c w]
                                              (assoc c (str (:level w) "#" (:type w)) w)
                                              )
                                            {} location-warnings)]
    clustered-location-warnings
    ))


(defn get-clustered-sorted-actual-location-warnings [locationId]
  (let [location-warnings (get-actual-location-warnings locationId)
        clustered-location-warnings (reduce (fn [c w]
                                              (assoc c (:type w) {:maxLevel (max (get-in c [(:type w) :maxLevel]) (:level w))
                                                                  :type     (:type w)
                                                                  :warnings (conj (or (get-in c [(:type w) :warnings]) []) w)})
                                              )
                                            {} location-warnings)]
    (reverse (sort-by (fn [[k v]] (:maxLevel v)) clustered-location-warnings))
    ))

;(get-clustered-sorted-actual-location-warnings "bFFpbdwJ6Kzq4sUsB9IW" )

(defn count-actual-location-warnings [locationId]
  (count (get-clustered-actual-location-warnings locationId)))




(defn count-all-actual-location-warnings []
  (reduce (fn [c [locationId d-location]]
            (+ c (count-actual-location-warnings locationId))
            )
          0
          @(r/cursor store/app-state [:locations])))





;(get-actual-location-warnings "bFFpbdwJ6Kzq4sUsB9IW")

;(count-actual-location-warnings "bFFpbdwJ6Kzq4sUsB9IW")

;(mapv first (get-filtered-warnings))
;
;(location-in @(r/cursor store/app-state [:locations "bFFpbdwJ6Kzq4sUsB9IW"]) @(r/cursor store/app-state [:warnings "62c2cbb9-8963-4dde-8041-098051b10c21"]))
;(location-in @(r/cursor store/app-state [:locations "bFFpbdwJ6Kzq4sUsB9IW"]) @(r/cursor store/app-state [:warnings "test"]))
;
;(get-in @(r/cursor store/app-state [:locations "bFFpbdwJ6Kzq4sUsB9IW"]) [:warning-type "zamg_1"])
;(get-in @(r/cursor store/app-state [:warnings "62c2cbb9-8963-4dde-8041-098051b10c21"]) [:type])






